module.exports = __webpack_public_path__ + "static/media/screenshot2.18ed5aca.png";